import { render, staticRenderFns } from "./Servicelist.vue?vue&type=template&id=41c5ad49&scoped=true&"
import script from "./Servicelist.vue?vue&type=script&lang=js&"
export * from "./Servicelist.vue?vue&type=script&lang=js&"
import style0 from "./Servicelist.vue?vue&type=style&index=0&id=41c5ad49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c5ad49",
  null
  
)

export default component.exports